import apiClientService from "./ApiClientService";

// Fotografia de profil (personalul). target: "me" sau id-ul contului (administratorul — oricui din personal,
// managerul — instructorilor; serverul verifică). Fișierul trimis e deja micșorat în browser (utils/avatarResize.js);
// serverul îl redesenează oricum 256×256 WebP.

async function readOrThrow(res, fallback) {
   if (res.ok) return res.json();
   let msg = fallback;
   try {
      const err = await res.json();
      if (err?.message) msg = Array.isArray(err.message) ? err.message.join(" ") : err.message;
   } catch {}
   if (res.status === 413) msg = "Fotografia e prea mare (cel mult 1 MB).";
   const error = new Error(msg);
   error.status = res.status;
   throw error;
}

const pathFor = (target) => (target === "me" ? "/users/me/avatar" : `/users/${Number(target)}/avatar`);

export async function uploadAvatar(target, blob) {
   const fd = new FormData();
   fd.append("file", blob, "fotografie.jpg");
   return readOrThrow(await apiClientService.post(pathFor(target), fd), "Nu am putut salva fotografia.");
}

export async function removeAvatar(target) {
   return readOrThrow(await apiClientService.delete(pathFor(target)), "Nu am putut șterge fotografia.");
}
